import axios from 'axios'
import {AuthModel, UserModel} from './_models'

const API_URL = process.env.REACT_APP_BACKEND_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/verify_token`
export const LOGIN_URL = `${API_URL}/auth/admin/login`

// Server should return AuthModel

export async function login(email: string, password: string): Promise<AuthModel> {
  try {
    const response = await axios.post(LOGIN_URL, { email, password });
    return response.data.data as AuthModel;
  } catch (error) {
    console.error("Login error:", error);
    throw error; // Re-throw the error to be handled by the caller
  }
}
